import { router } from '@inertiajs/vue3';

export function useTributosNavigation() {
    const getTributosRoute = () => route('tributos');
    const getDebitosPorContribuinteRoute = () => route('tributos.contribuinte');
    const getDebitosPorImovelRoute = () => route('tributos.imovel');
    const getDebitosPorInscricaoRoute = () => route('tributos.inscricao');

    const goToTributos = () => router.visit(getTributosRoute());
    const goToDebitosPorContribuinte = () => router.visit(getDebitosPorContribuinteRoute());
    const goToDebitosPorImovel = () => router.visit(getDebitosPorImovelRoute());
    const goToDebitosPorInscricao = () => router.visit(getDebitosPorInscricaoRoute());

    return {
        getTributosRoute, getDebitosPorContribuinteRoute, getDebitosPorImovelRoute, getDebitosPorInscricaoRoute,
        goToTributos, goToDebitosPorContribuinte, goToDebitosPorImovel, goToDebitosPorInscricao
    };
}
